"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyMeta = void 0;
var React = require("react");
/**
 * e.g. <meta property="og:title" content="Top 10 Boston Hotels $127 | Boston Hotel Deals in 2018 on Expedia"/>
 */
var PropertyMeta = /** @class */function () {
  function PropertyMeta(property, content) {
    this.property = property;
    this.content = content;
  }
  PropertyMeta.prototype.renderMetaElement = function () {
    return React.createElement("meta", {
      property: this.property,
      content: this.content
    });
  };
  return PropertyMeta;
}();
exports.PropertyMeta = PropertyMeta;